/**
 * Query Key factory for all immunization queries.
 *
 * @module Immunization
 */

import { Pagination } from "@customTypes/index";


export const immunizationQKeys = {
  all: () => ["immunizations"] as const,

  patients: () => [...immunizationQKeys.all(), "patient"] as const,

  patient: (patientId: string) =>
    [...immunizationQKeys.patients(), patientId] as const,

  patientWithFilters: (
    patientId: string,
    filters?: {
      pagination?: Partial<Pagination>;
      withFilesOnly?: boolean;
      fastConsultationOnly?: boolean;
      search?: string;
    }
  ) => [...immunizationQKeys.patient(patientId), { ...filters }] as const,
};
